import _remove from 'lodash/remove';
import _debounce from 'lodash/debounce';
import viewStudentsTemplate from './../view-students/view-students.html';
import showSubstitutionTemplate from './../../informations/working-days/show-substitution/show-substitution.html';
import template from './realizations-by-group.html';

class RealizationsByGroupComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    RealizationService,
    SubstitutionService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.RealizationService = RealizationService;
    this.SubstitutionService = SubstitutionService;

    this.realizations = [];
    this.dateTo = this.moment().toDate();
    this.dateFrom = this.moment().subtract(7, 'days').toDate();
    this.loadPageCallbackWithDebounce = {};
  }

  $onInit() {
    if (this.groups) {
      this.group = this.groups[0];
    }
  }

  $onChanges(changes) {
    if (changes.groups) {
      this.groups = Object.assign([], this.groups);
      _remove(this.groups, group => group.default);
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page, pageSize) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    return this.RealizationService.getByGroup({
      groupId: this.group.id,
      dateFrom: this.moment(this.dateFrom).format('YYYY-MM-DD'),
      dateTo: this.moment(this.dateTo).format('YYYY-MM-DD'),
      offset,
      limit: pageSize
    }).then(result => {
      this.realizations = result.data.realizations.map(realization => {
        realization.description = {
          value: realization.description,
          substitution: Boolean(realization.substituteActivity),
          substituteActivity: realization.substituteActivity
        };
        return realization;
      });
      return {
        results: result.data.realizations,
        totalResultCount: result.data.total
      };
    });
  }

  setFilter(form) {
    if (form.$invalid) {
      return false;
    }

    this.loadPageCallbackWithDebounce();
  }

  openAttendances(students, ev) {
    if (students.length > 0) {
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'ViewStudentsController',
        template: viewStudentsTemplate,
        locals: {students},
        clickOutsideToClose: true,
        targetEvent: ev
      });
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Brak uczniów na zajęciach')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  openSubstitution(substituteActivityId, ev) {
    if (angular.isDefined(substituteActivityId)) {
      this.SubstitutionService.getActivity(substituteActivityId)
        .then(substituteActivitie => {
          this.$mdDialog.show({
            bindToController: true,
            controllerAs: 'ctrl',
            controller: 'ShowSubstitutionController',
            template: showSubstitutionTemplate,
            locals: {
              substituteActivitie
            },
            clickOutsideToClose: true,
            targetEvent: ev
          });
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    }
  }

  remove(id, ev) {
    ev.stopPropagation();
    this.RealizationService.delete({id}).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto realizację')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się usunąć rozmowy')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}

export const RealizationsByGroup = {
  bindings: {
    groups: '<'
  },
  template,
  controller: RealizationsByGroupComponent
};
